import React from 'react';
import { Box, styled, useMediaQuery } from '@mui/material';
import Modal from '../modal';

// Styles to get a responsive iframe.
const SupportContainer = styled(Box)`
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
  && iframe,
  && object,
  && embed {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 50%;
    height: 50%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    padding-top: 0px;
    height: 80%;
  }
`;

interface SupportModalProps {
  open: boolean;
  onClose: () => void;
}

const CustomH1 = styled('h1')(({ theme }) => ({
  fontFamily: 'HCo Gotham SSm,Gotham,sans-serif',
  textTransform: 'capitalize',
  fontSize: '24px',
  lineHeight: '24px',
  marginBottom: theme.spacing(3),
}));

const CustomPara = styled('p')(({ theme }) => ({
  fontFamily: 'HCo Gotham SSm,Gotham,sans-serif',
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 'normal',
  marginBottom: theme.spacing(3),
}));

const CustomParaB = styled('span')(({ theme }) => ({
  fontFamily: 'HCo Gotham SSm,Gotham,sans-serif',
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 'bold',
  marginBottom: theme.spacing(3),
}));

const SupportModal: React.FC<SupportModalProps> = ({ open, onClose }) => (
  <Modal open={open} onClose={() => onClose()}>
    <CustomH1>Support</CustomH1>
    <SupportContainer
      className="SupportContainer"
      margin={{
        sm: '25% 0',
        md: '0',
      }}
    >
      <CustomPara>
        For Dev One Support, please sign in to your HP account or create an HP
        account to initiate a support ticket to get expert help from our support
        teams.
      </CustomPara>
      <CustomPara>
        Or please email our support team directly at{' '}
        <CustomParaB>support@hpdevone.com.</CustomParaB>
      </CustomPara>
      <CustomPara>
        Our technical support team is available to help Monday to Sunday, 5:00am
        to 5:00pm Pacific Standard Time.
      </CustomPara>
      <CustomPara>
        For order status inquiries, support is available Monday to Friday,
        8:30am to 5:00pm Mountain Standard Time.
      </CustomPara>
    </SupportContainer>
  </Modal>
);

export default SupportModal;
